export const AUTH_TOKEN_KEY = "token";
export const AUTH_USER_KEY = "user";
export const QUICK_SESSION_TOKEN_KEY = "quick_session_token";
export const PIN_AUTHENTICATED_KEY = "pin_authenticated";

const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padding = "=".repeat((4 - (normalized.length % 4)) % 4);
  return atob(normalized + padding);
};

export const parseJwtPayload = (token) => {
  try {
    const parts = String(token || "").split(".");
    if (parts.length < 2) return null;
    return JSON.parse(decodeBase64Url(parts[1]));
  } catch {
    return null;
  }
};

export const isTokenExpired = (token) => {
  if (!token) return true;
  const payload = parseJwtPayload(token);
  if (!payload || !payload.exp) return false;
  return payload.exp * 1000 <= Date.now();
};

export const markPinAuthenticated = () => {
  sessionStorage.setItem(PIN_AUTHENTICATED_KEY, "true");
};

export const clearPinAuthenticated = () => {
  sessionStorage.removeItem(PIN_AUTHENTICATED_KEY);
};

export const isPinAuthenticated = () =>
  sessionStorage.getItem(PIN_AUTHENTICATED_KEY) === "true";

export const clearStoredAuth = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(QUICK_SESSION_TOKEN_KEY);
  clearPinAuthenticated();
};

export const clearAccessAuth = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  clearPinAuthenticated();
};

export const getHomeRouteForRole = (role) => {
  const normalizedRole = String(role || "").toLowerCase();

  if (normalizedRole === "admin") return "/dashboard";
  if (normalizedRole === "subadmin") return "/reports";
  if (normalizedRole === "tl") return "/tasks";
  if (normalizedRole === "employee") return "/tasks";
  return "/unauthorized";
};
